export { AccredibleChipComponent } from './lib/chip.component';
export * from './lib/chip.component.module';
